import { Box, Typography, SxProps } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ReactNode } from 'react';

interface CenteredContentLayoutProps {
  image: {
    src: string;
    alt: string;
  };
  title: string;
  description: string;
  button?: {
    text: string;
    onClick: () => void;
    loading?: boolean;
  };
  maxWidth?: string | number;
  children?: ReactNode;
  containerSx?: SxProps;
  imageMaxWidth?: string | number;
}

export default function CenteredContentLayout({
  image,
  title,
  description,
  button,
  maxWidth = '768px',
  children,
  containerSx,
  imageMaxWidth = '280px',
}: CenteredContentLayoutProps) {
  return (
    <Box
      width="100%"
      maxWidth={maxWidth}
      mx="auto"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={4}
      sx={containerSx}>
      <Box
        width="100%"
        maxWidth={imageMaxWidth}
        sx={{
          aspectRatio: '1/1',
        }}>
        <img
          src={image.src}
          alt={image.alt}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography variant="h1" textAlign="center" fontWeight="700">
          {title}
        </Typography>
        <Typography variant="body1" textAlign="center">
          {description}
        </Typography>
      </Box>
      {button && (
        <LoadingButton
          sx={{
            width: {
              xs: '100%',
              sm: 'auto',
            },
          }}
          onClick={button.onClick}
          loading={button.loading}
          variant="base"
          color="primary">
          <Typography variant="inherit" fontWeight="600">
            {button.text}
          </Typography>
        </LoadingButton>
      )}
      <Box width="100%" display="flex" flexDirection="column" gap={4}>
        {children}
      </Box>
    </Box>
  );
}
